module.exports = __webpack_public_path__ + "img/heroes_study_grade_bg.1c8d61d4.png";